import { FormDialog, FormDialogProps, FormInput, Grid } from '@kirz/mui-admin';
import React, { ReactNode } from 'react';

export type EditProjectDialogProps = Partial<FormDialogProps> & {
  open: boolean;
  onClose: () => void;
  formHeader?: ReactNode;
};

export function EditProjectDialog({
  entityId,
  formHeader,
  ...props
}: EditProjectDialogProps) {
  return (
    <FormDialog
      {...props}
      source="project"
      entityId={entityId}
      maxWidth="sm"
      autoFocus={false}
      title={entityId ? 'Edit project' : 'Create new project'}
    >
      {formHeader && <Grid xs={12}>{formHeader}</Grid>}
      <FormInput name="name" label="Project name" required />
    </FormDialog>
  );
}
